import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { X } from 'lucide-react';
import { IconButton } from './Button';
import { cx } from './cx';
import styles from './Sheet.module.css';

/**
 * Dialog für Formulare und Details: auf dem Handy als Blatt von unten, ab Tablet zentriert.
 * Fokus bleibt im Dialog, Escape und Tippen daneben schließen ihn.
 * @param {'sm'|'md'|'lg'} size
 */
export function Sheet({ open, onClose, title, description, footer, size = 'md', dismissible = true, className, children }) {
  const close = dismissible ? onClose : () => { };
  return (
    <Dialog open={open} onClose={close} className={styles.root}>
      <DialogBackdrop transition className={styles.backdrop} />
      <div className={styles.viewport}>
        <DialogPanel transition className={cx(styles.panel, styles[size], className)}>
          <div className={styles.handle} aria-hidden />
          <header className={styles.header}>
            <div className={styles.headerText}>
              <DialogTitle className={styles.title}>{title}</DialogTitle>
              {description && <p className={styles.description}>{description}</p>}
            </div>
            {dismissible && <IconButton icon={X} label="Schließen" onClick={onClose} />}
          </header>
          <div className={styles.body}>{children}</div>
          {footer && <footer className={styles.footer}>{footer}</footer>}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
